import * as XLSX from "xlsx";
import moment from "moment";
const {
  REACT_APP_ENV_MODE,
  REACT_APP_API_DEVELOPMENT,
  REACT_APP_API_STAGING,
  REACT_APP_API_PRODUCTION,
} = process.env;
const DownloadExcel = (data, filename) => {
  const mainHeading =
    filename + " Excel Data, Export on " + moment().format("DD-MM-YYYY");
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(data);
  // XLSX.utils.sheet_add_aoa(worksheet, [[mainHeading]], { origin: 'A1' });
  XLSX.utils.book_append_sheet(workbook, worksheet, filename);
  XLSX.writeFile(
    workbook,
    `${
      moment().milliseconds() +
      1000 * (moment().seconds() + 60 * 60) +
      `-${filename}`
    }.xlsx`
  );
  return true;
};

const SampleFileDownload = (sectionName) => {
  let url = "";
  if (REACT_APP_ENV_MODE === "development") {
    url = REACT_APP_API_DEVELOPMENT;
  } else if (REACT_APP_ENV_MODE === "staging") {
    url = REACT_APP_API_STAGING;
  } else if (REACT_APP_ENV_MODE === "production") {
    url = REACT_APP_API_PRODUCTION;
  }
  let fileUrl = url + "/sample.xlsx";
  if (sectionName == "Brand") {
    fileUrl = url + "/Sample-Brand.xlsx";
  } else {
    fileUrl = url + "/Sample-Model.xlsx";
  }
  const link = document.createElement("a");
  link.href = fileUrl;
  link.download = `Sample-${
    moment().milliseconds() + 1000 * (moment().seconds() + 60 * 60)
  }-${sectionName}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export { DownloadExcel, SampleFileDownload };
